export default "__VITE_ASSET__CxOQ_QP5__"